export default __webpack_public_path__ + "static/media/weather2.311546e5.jfif";